"use client";

import { resolveNumber } from "./binding";
import { MACARON } from "./tokens";
import type { MacaronRenderContext, RecordAny } from "./types";

export function MacaronLinearProgress({ config, ctx }: { config: RecordAny; ctx: MacaronRenderContext }) {
  const p = Math.max(0, Math.min(1, resolveNumber(config.progress, ctx.data)));
  return (
    <div className="h-2 w-full overflow-hidden rounded-full" style={{ backgroundColor: MACARON.progressTrack }}>
      <div
        className="h-full rounded-full transition-[width] duration-200 ease-out"
        style={{ width: `${p * 100}%`, backgroundColor: MACARON.progressFill }}
      />
    </div>
  );
}
